module.exports = __webpack_public_path__ + "img/AfCFTA Logo.3e872659.png";